<template>
  <div class="modal" :class="{ shown: dialogData.shown }">
    <div class="modal__background" v-on:click="close"></div>
    <div class="modal__popup popup">
      <form class="form">
        <div class="popup__header bg-black01">
          <h3>{{ dialogData.title }}</h3>
          <button
            type="button"
            class="button popup__header__close"
            aria-label="Close"
            v-on:click="close"
          >
            <close></close>
          </button>
        </div>
        <div class="overflow-auto">
          <div class="popup__content">
            <div>
              <div
                v-for="(field, index) in dialogData.fields"
                :key="index"
                class="form-field"
              >
                <template v-if="field.type == 'text'">
                  <label :for="field.property" class="text-black01">{{
                    field.label
                  }}</label>
                  <input
                    class="w-full"
                    :class="field.class"
                    type="text"
                    :id="`${field.property}`"
                    :name="`${field.property}`"
                    v-model="field.value"
                  />
                </template>
                <template v-else-if="field.type == 'select'">
                  <label :for="`${field.property}`" class="text-black01">{{
                    field.label
                  }}</label>
                  <v-select
                    class=""
                    :class="field.class"
                    :id="field.property"
                    :name="field.property"
                    :options="field.options"
                    :reduce="x => x.value"
                    label="label"
                    v-model.number="field.value"
                  ></v-select>
                </template>
                <template v-else-if="field.type == 'daterange'">
                  <label :for="`${field.property}`" class="text-black01">{{
                    field.label
                  }}</label>
                  <date-picker
                    class="w-full"
                    :id="field.start.property"
                    :name="field.start.property"
                    :class="field.start.class"
                    :format="field.start.format"
                    :type="field.start.type"
                    :value-type="field.start.value_type"
                    v-model="field.start.value"
                  ></date-picker>
                  <span class="mx-4px">〜</span>
                  <date-picker
                    class="w-full"
                    :id="field.end.property"
                    :name="field.end.property"
                    :class="field.end.class"
                    :format="field.end.format"
                    :type="field.end.type"
                    :value-type="field.end.value_type"
                    v-model="field.end.value"
                  ></date-picker>
                </template>
              </div>
            </div>
          </div>
          <div class="popup__footer">
            <input
              class="button bg-black01"
              type="button"
              :value="'クリア'"
              v-on:click="reset"
            />
            <input
              class="button bg-black01"
              type="button"
              :value="dialogData.submitLabel"
              v-on:click="submit"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dialogData: Object
  },
  data() {
    return {};
  },
  methods: {
    close: function() {
      this.$emit("close-dialog");
    },
    submit: function() {
      this.$emit("submit-search");
    },
    reset: function() {
      this.dialogData.fields.forEach(field => {
        if (field.start.property) {
          field.start.value = field.start.default;
        }
        if (field.end.property) {
          field.end.value = field.end.default;
        }
        if (field.property) {
          field.value = field.default;
        }
      });
    }
  },
  mounted() {}
};
</script>
